import { createThunkEffect } from "../../utilities/ActionUtility";
import * as PublicLinkEffect from "./PublicLinkEffect";

export const REQUEST_PUBLIC_LINKS = "OrdersEffect.REQUEST_PUBLIC_LINKS";
export const REQUEST_PUBLIC_LINKS_FINISHED = "OrdersEffect.REQUEST_PUBLIC_LINKS_FINISHED";

export function requestPublicLinks(orderId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_PUBLIC_LINKS, PublicLinkEffect.requestPublicLinks, orderId);
    };
}

export const REQUEST_ADD_PUBLIC_LINK = "OrdersEffect.REQUEST_ADD_PUBLIC_LINK";
export const REQUEST_ADD_PUBLIC_LINK_FINISHED = "OrdersEffect.REQUEST_ADD_PUBLIC_LINK_FINISHED";

export function addPublicLink(orderId, days) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_PUBLIC_LINK, PublicLinkEffect.addPublicLink, orderId, days);
    };
}

export const REQUEST_DELETE_PUBLIC_LINK = "OrdersEffect.REQUEST_DELETE_PUBLIC_LINK";
export const REQUEST_DELETE_PUBLIC_LINK_FINISHED = "OrdersEffect.REQUEST_DELETE_PUBLIC_LINK_FINISHED";

export function deletePublicLink(publicLinkId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_DELETE_PUBLIC_LINK, PublicLinkEffect.deletePublicLink, publicLinkId);
    };
}
